import { useNavigate } from "react-router";
import { useGlobalContext } from "app/store/GlobalContext";
import Modal from "components/modal/Modal";
import ModalFooter from "components/modal/ModalFooter";

type Props = {
  text?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onDismiss?: () => void;
};

export default function UnsavedChangesModal({ 
  text, 
  onConfirm: customOnConfirm, 
  onCancel: customOnCancel, 
  onDismiss: customOnDismiss 
}: Props) {
  const { redirectingState, setRedirectingState, setEditingState } =
    useGlobalContext();
  const navigate = useNavigate();

  const handleCancelClick = () => {
    if (customOnCancel) {
      customOnCancel();
      return;
    }
    
    setRedirectingState({
      url: "",
      isRedirecting: false,
      clickEvent: undefined,
      shouldHardRedirect: false
    });
  };

  const handleContinueClick = () => {
    if (customOnConfirm) {
      customOnConfirm();
      return;
    }
    
    setEditingState({ isEditing: false, location: null });

    if (redirectingState.clickEvent) {
      redirectingState.clickEvent();
    }

    if (redirectingState.shouldHardRedirect && redirectingState.url === "/") {
      window.location.href = redirectingState.url;
    } else {
      if (typeof redirectingState.url === "number") {
        navigate(redirectingState.url); // navigate(-1)
      } else {
        navigate(redirectingState.url); // navigate("/path")
      }
    }

    setRedirectingState({
      url: "",
      isRedirecting: false,
      clickEvent: undefined,
      shouldHardRedirect: false
    });
  };

  const handleDismissClick = () => {
    if (customOnDismiss) {
      customOnDismiss();
      return;
    }
    
    setRedirectingState({
      url: "",
      isRedirecting: false,
      clickEvent: undefined,
      shouldHardRedirect: false
    });
  };

  return (
    <Modal
      header={<h1 className="m-0">Ej sparade ändringar</h1>}
      onDismiss={handleDismissClick}
      size="sm"
      modalTitle="unsaved change"
      footer={
        <ModalFooter
          onConfirm={handleContinueClick}
          onCancel={handleCancelClick}
          confirmText="Fortsätt"
        />
      }
    >
      <div className="modalText">
        <p>
          {text ||
            "Du har ändringar som ej sparats. Är du säker på att du vill lämna sidan?"}
        </p>
      </div>
    </Modal>
  );
}
